import "bootstrap/dist/css/bootstrap.min.css";
import React, { ReactElement, useState } from "react";
import { Col, Container, Pagination, Row, Toast, ToastContainer } from "react-bootstrap";
import { commonStrings } from "../../../../../../core";
import { NavbarLinks, PartsList } from "../../../../../../ds";
import {
  FiltersMoreParts,
  MorePartsContentProps,
  MorePartsData,
  MorePartsPageControllerImpl,
} from "../../../../business";
import { MorePartsFilterFactoryImpl } from "../../factories";
import { FilterSearch, FilterSidebar } from "./";

export const MorePartsContent: React.FC<MorePartsContentProps> = ({ data }) => {
  const cs = commonStrings().PTBR;
  const controller = new MorePartsPageControllerImpl();
  const [filterMoreParts, setFilterMoreParts] = useState([]);
  const [morePartsData, setMorePartsData] = useState<MorePartsData>(data);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [toasting, setToasting] = useState<string | null>(null);
  const factory = new MorePartsFilterFactoryImpl();

  const setFilter = async (filter, page: number = 1) => {
    setLoading(true);
    setFilterMoreParts(filter);
    let filterDone: FiltersMoreParts = {};

    filter.forEach((element) => {
      const keys = Object.keys(element);

      keys.forEach((key) => {
        if (filterDone[key]) {
          if (Array.isArray(filterDone[key])) {
            filterDone[key].push(element[key]);
          } else {
            filterDone[key] = [filterDone[key], element[key]];
          }
        } else {
          filterDone[key] = [element[key]];
        }
      });
    });
    const response = await controller.applyFilters(filterDone, page);
    try {
      setMorePartsData(factory.create(response));
    } catch (error) {
      setFilterMoreParts([]);
      setToasting(error.message);
    }
    setLoading(false);
  };

  const renderPagination = () => {
    if (morePartsData.pagination / morePartsData.limit > 1) {
      const pages = Math.ceil(morePartsData.pagination / morePartsData.limit);
      let items: ReactElement[] = [];
      for (let number = 1; number <= pages; number++) {
        items.push(
          <Pagination.Item
            key={morePartsData.pagination}
            active={number === morePartsData.page}
            onClick={() => setFilter(filterMoreParts, number)}>
            {number}
          </Pagination.Item>
        );
      }
      return <Pagination size="sm">{items}</Pagination>;
    } else {
      return <></>;
    }
  }

  return (
    <>
      <Row>
        <Col className="d-none d-lg-block overflow-hidden" lg={3}>
          <FilterSearch
            header={true}
            data={morePartsData.filters}
            filterStore={filterMoreParts}
            onFilter={setFilter}
            isLoading={isLoading}
          />
        </Col>
        <Col xs={12} sm={12} md={12} lg={9}>
          <NavbarLinks activeKey={2} />

          <Container className="d-block d-lg-none flex">
            <FilterSidebar
              title={cs.filter.title}
              morePartsDataFilters={morePartsData.filters}
              filterMoreParts={filterMoreParts}
              setFilter={setFilter}
              isLoading={isLoading}
            />
          </Container>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <PartsList items={morePartsData.moreparts} />
            </Col>
          </Row>
          {renderPagination()}
        </Col>
      </Row>
      <ToastContainer position="bottom-center" className="p-3" style={{ zIndex: 1 }}>
        <Toast
          bg={"danger"}
          onClose={() => setToasting(null)}
          show={toasting !== null ? true : false}
          delay={5000}
          autohide
        >
          <Toast.Body className={"text-white"}>
            {toasting !== null ? toasting : null}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
